var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _style, _path, _path2, _tspan, _path3, _circle, _text, _path4, _circle2, _text2, _path5, _circle3, _text3, _path6, _circle4, _tspan2, _path7, _circle5, _text4, _path8, _circle6, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFutureVertical = function SvgFutureVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "future_vertical_svg__Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 167.74 482.78"
  }, props), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.74,
    dy: 0.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.74
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.74,
    dy: 0.74
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0.74
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "future_vertical_svg__drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 0.96
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29",
    "data-name": "Gradient sans nom 29",
    x1: -350.78,
    y1: -255.21,
    x2: -360.52,
    y2: -281.98,
    gradientTransform: "rotate(90 -331.155 142.205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d28282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ef9f99"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29-2",
    "data-name": "Gradient sans nom 29",
    x1: -1582.71,
    y1: -1287.33,
    x2: -1592.48,
    y2: -1314.18,
    gradientTransform: "scale(1 -1) rotate(-2.61 24509.665 -36607.201)",
    xlinkHref: "#future_vertical_svg__Gradient_sans_nom_29"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29-3",
    "data-name": "Gradient sans nom 29",
    x1: -248.18,
    y1: -255.21,
    x2: -257.93,
    y2: -281.98,
    xlinkHref: "#future_vertical_svg__Gradient_sans_nom_29"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29-4",
    "data-name": "Gradient sans nom 29",
    x1: -1578.04,
    y1: -1389.82,
    x2: -1587.82,
    y2: -1416.67,
    gradientTransform: "scale(1 -1) rotate(-2.61 24509.665 -36607.201)",
    xlinkHref: "#future_vertical_svg__Gradient_sans_nom_29"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29-5",
    "data-name": "Gradient sans nom 29",
    x1: -145.51,
    y1: -255.21,
    x2: -155.25,
    y2: -281.98,
    xlinkHref: "#future_vertical_svg__Gradient_sans_nom_29"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_vertical_svg__Gradient_sans_nom_29-6",
    "data-name": "Gradient sans nom 29",
    x1: -1573.38,
    y1: -1492.39,
    x2: -1583.15,
    y2: -1519.23,
    gradientTransform: "scale(1 -1) rotate(-2.61 24509.665 -36607.201)",
    xlinkHref: "#future_vertical_svg__Gradient_sans_nom_29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "future_vertical_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h167.74v474H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".future_vertical_svg__cls-3{font-family:inherit}.future_vertical_svg__cls-12,.future_vertical_svg__cls-13{fill:#4c4c4c}.future_vertical_svg__cls-17{stroke:#4c4c4c;stroke-miterlimit:10;stroke-width:.35px;fill:none}.future_vertical_svg__cls-13{font-size:5px}.future_vertical_svg__cls-32{font-family:inherit}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#future_vertical_svg__clippath)"
    },
    id: "future_vertical_svg__Accueil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.36 11.87C57.96 21.82 38.4 48.08 38.4 78.92c0 20.15 8.36 38.34 21.79 51.31 12.83 12.38 30.29 20 49.53 20 .8 0 1.6-.01 2.4-.04 25.55-.84 25.55-39.08 0-39.93-.8-.03-1.59-.04-2.4-.04-19.24 0-36.7 7.62-49.53 20-13.43 12.97-21.79 31.16-21.79 51.31s8.36 38.34 21.79 51.31c12.83 12.38 30.29 20 49.53 20 .8 0 1.6-.01 2.4-.04 25.55-.84 25.55-39.08 0-39.93-.8-.03-1.59-.04-2.4-.04-19.24 0-36.7 7.62-49.53 20-13.43 12.97-21.79 31.16-21.79 51.31s8.36 38.34 21.79 51.31c12.83 12.39 30.29 20 49.53 20 .8 0 1.6-.01 2.4-.04 25.55-.84 25.55-39.08 0-39.93-.8-.03-1.59-.04-2.4-.04-19.24 0-36.7 7.62-49.53 20-13.43 12.97-21.79 31.17-21.79 51.31v87.21",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "17.56px",
      stroke: "#ef9f99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92 118.03c3.76 4.42 8.01 8.57 13.05 12.21 4.86-3.31 10.3-6.15 16.7-8.35l-4.21-17c-9.45 2.89-17.87 7.32-25.54 13.14Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.24 130.23c3.28 3.91 8.71 8.92 12.68 12.21-3.76 4.82-7.02 9.66-10.01 17.68l-16.86-4.86c3.45-9.82 8.02-17.65 14.19-25.04Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92 220.62c3.76 4.42 8.01 8.57 13.05 12.21 4.86-3.31 10.3-6.15 16.7-8.35l-4.21-17c-9.45 2.89-17.87 7.32-25.54 13.14Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.24 232.83c3.28 3.91 8.71 8.92 12.68 12.21-3.76 4.82-7.02 9.66-10.01 17.68l-16.86-4.86c3.45-9.82 8.02-17.65 14.19-25.04Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92 323.3c3.76 4.42 8.01 8.57 13.05 12.21 4.86-3.31 10.3-6.15 16.7-8.35l-4.21-17c-9.45 2.89-17.87 7.32-25.54 13.14Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.24 335.5c3.28 3.91 8.71 8.92 12.68 12.21-3.76 4.82-7.02 9.66-10.01 17.68l-16.86-4.86c3.45-9.82 8.02-17.65 14.19-25.04Z",
    style: {
      fill: "url(#future_vertical_svg__Gradient_sans_nom_29-6)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M131.09 351.25v-15.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-12",
    d: "M132.41 335.65c0-.73-.59-1.32-1.32-1.32s-1.32.59-1.32 1.32.59 1.32 1.32 1.32 1.32-.59 1.32-1.32Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.28,
    y: 349.35,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-3)",
      fill: "#bee5cf"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(120.48 357.19)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fin 2025"))), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.91,
    y: 6,
    style: {
      letterSpacing: 0
    }
  }, "Expansion \uD83C\uDF0E"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M38.66 295.73v-15.67"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 38.66,
    cy: 280.13,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.85,
    y: 293.83,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-4)",
      fill: "#bee5cf"
    }
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(22.56 301.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Courant 2025")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 6
  }, "Nouveaux cr\xE9ateurs")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M131.1 248.56v-15.67"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 131.1,
    cy: 232.96,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.29,
    y: 246.66,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-5)",
      fill: "#bee5cf"
    }
  }), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(124.58 254.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "D\xE9but 2025")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.57,
    y: 6
  }, "S\xE9lection des projets")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M38.66 192.97v-15.66"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 38.66,
    cy: 177.37,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.85,
    y: 191.08,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-6)",
      fill: "#bee5cf"
    }
  }), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(28.05 198.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fin 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 6
  }, "Appel \xE0 projet")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M131.17 145.57V129.9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 131.17,
    cy: 129.97,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.36,
    y: 143.67,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      fill: "#bee5cf",
      filter: "url(#future_vertical_svg__drop-shadow-7)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(120.64 151.51)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mi-2024"))), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14,
    y: 6,
    style: {
      letterSpacing: "-.02em"
    }
  }, "D\xE9but du crowdfunding"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M38.69 94.48V78.82"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 38.69,
    cy: 78.88,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.88,
    y: 92.59,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-8)",
      fill: "#bee5cf"
    }
  }), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(24.9 100.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mars 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.45,
    y: 6
  }, "Premi\xE8re campagne")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "future_vertical_svg__cls-17",
    d: "M86.36 27.18V11.51"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "future_vertical_svg__cls-12",
    cx: 86.36,
    cy: 11.58,
    r: 1.32
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.55,
    y: 25.28,
    width: 62.64,
    height: 19.44,
    rx: 1,
    ry: 1,
    style: {
      filter: "url(#future_vertical_svg__drop-shadow-9)",
      fill: "#bee5cf"
    }
  }), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "future_vertical_svg__cls-13",
    transform: "translate(79.84 33.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 0
  }, "Mars 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_vertical_svg__cls-32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.65,
    y: 6
  }, "Lancement de KuneKune"))))));
};
export default SvgFutureVertical;